const tod22 = [...Array(100).keys()].map((x) =>
  x.length == 1 ? `0${x}` : `${x}`
);

export const tod2 = tod22.map((x) => (x.length == 1 ? `0${x}` : `${x}`));
